import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    clientId: String,
    pdfUrl: String,
    fileName: String,
    config: Object,
    locale: { type: String, default: "nl-NL" }
  }

  static targets = ["skeleton"]

  connect() {
    this.loadAdobeSDK()
  }

  loadAdobeSDK() {
    if (window.AdobeDC) {
      this.initializeViewer()
      return
    }

    if (document.querySelector('script[src*="documentcloud.adobe.com"]')) {
      // Script is loading, wait for it
      this.waitForAdobeSDK()
      return
    }

    // Load the script
    const script = document.createElement('script')
    script.src = 'https://documentcloud.adobe.com/view-sdk/viewer.js'
    script.onload = () => this.waitForAdobeSDK()
    document.head.appendChild(script)
  }

  waitForAdobeSDK() {
    if (typeof window.AdobeDC !== 'undefined') {
      this.initializeViewer()
    } else {
      setTimeout(() => this.waitForAdobeSDK(), 100)
    }
  }

  initializeViewer() {
    // Find the PDF viewer div (child with an id)
    const viewerDiv = this.element.querySelector('[id]')

    const adobeDCView = new window.AdobeDC.View({
      clientId: this.clientIdValue,
      divId: viewerDiv.id,
      locale: this.localeValue
    })

    // Register callback to hide skeleton when PDF rendering starts
    adobeDCView.registerCallback(
      window.AdobeDC.View.Enum.CallbackType.EVENT_LISTENER,
      (event) => {
        if (event.type === "APP_RENDERING_START" && this.hasSkeletonTarget) {
          this.skeletonTarget.classList.add('d-none')
        }
      },
      { enablePDFAnalytics: true }
    )

    adobeDCView.previewFile({
      content: {
        location: {
          url: this.pdfUrlValue
        }
      },
      metaData: {
        fileName: this.fileNameValue
      }
    }, this.configValue)
  }
}
